import React from "react";
import { Button } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const TextButtonLarge = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"Large Text button"}
        value={"<Button variant={\"text\"} size={'large'}>Large</Button>"}
      >
        <Button variant={"text"} size={"large"}>
          Large
        </Button>
      </PreviewAndEditor>
    </>
  );
};

export default TextButtonLarge;
